// extracted by mini-css-extract-plugin
module.exports = {"list_group":"style_list_group__1XXG8","item200":"style_item200__3yk8I","new":"style_new__3JS65","itemImg":"style_itemImg__2u4pb"};